export const FormRoutes = {
    login: '/login',
    forgotPassword: '/password/forgot',
    newPassword: '/password/new',
    newEmail: '/email/new',
    legacyPassword: '/password/legacy',
    verifyPasswordToken: '/password/verify',
    verifyPasswordSuccess: '/password/verify-success',
    organisations: '/choose-organisation',
    currentSession: '/current-session',
    checkInbox: '/check-inbox',
    checkInboxError: '/check-inbox-error',
} as const;

export type FormRoutes = (typeof FormRoutes)[keyof typeof FormRoutes];

export const getParam = (paramName: string): string | null => {
    const searchParams = new URLSearchParams(globalThis.location.search);
    return searchParams.get(paramName);
};

export const getToken = (): string => getParam('token') || '';

const updateHistory = (pathname: string, search?: string) => {
    globalThis.history.pushState({ pathname }, '', `${import.meta.env.BASE_URL}${pathname}${search || ''}`);
};

const router = {
    pathname: globalThis.location.pathname.replace(import.meta.env.BASE_URL, ''),
    init(): void {
        if ((Object.values(FormRoutes) as string[]).includes(this.pathname)) {
            updateHistory(this.pathname, globalThis.location.search);
        }
        globalThis.addEventListener('popstate', ({ state }: PopStateEvent) => {
            const statePathname = (state as { pathname?: string } | null)?.pathname;
            if (statePathname && (Object.values(FormRoutes) as string[]).includes(statePathname)) {
                this.notify(statePathname);
            }
        });
    },
    listeners: [] as ((pathname: string, search: URLSearchParams) => void)[],
    go(pathname: FormRoutes, search?: string): void {
        updateHistory(pathname, search);
        this.notify(pathname);
        this.pathname = pathname;
    },
    notify(pathname: string): void {
        this.listeners.forEach(f => f(pathname, new URLSearchParams(globalThis.location.search)));
    },
    subscribe(f: (pathname: string, search: URLSearchParams) => void): void {
        f(this.pathname, new URLSearchParams(globalThis.location.search));
        this.listeners.push(f);
    },
};

router.init();

export default router;
